import type { DataState } from "../../shared/models";
import { Icon } from "./Icon";
import { relativeAge } from "./time";

const LABEL: Record<DataState, string> = {
  loading: "Loading",
  live: "Live",
  stale: "Not current",
  offline: "Offline",
  unavailable: "Unavailable",
  permissionRequired: "Sign-in needed",
  disabled: "Off",
};

/**
 * Small freshness indicator. Hidden while live (the normal case stays quiet);
 * any degraded state says so plainly with the age of what is shown.
 */
export function StatusBadge({ state, updatedAt, label }: { state: DataState; updatedAt?: number | string | null; label?: string }) {
  if (state === "live" || state === "loading") return null;
  const age = updatedAt ? ` · updated ${relativeAge(updatedAt)}` : "";
  return (
    <span className={`status-badge status-${state}`} role="status">
      {state === "offline" ? <Icon name="wifiOff" size={14} /> : <Icon name="info" size={14} />}
      {label ?? LABEL[state]}
      {age}
    </span>
  );
}

/** Full-widget message for when there is nothing (cached or live) to show. */
export function EmptyState({ icon = "info", title, detail, action }: { icon?: Parameters<typeof Icon>[0]["name"]; title: string; detail?: string; action?: React.ReactNode }) {
  return (
    <div className="empty-state">
      <Icon name={icon} size={28} />
      <strong>{title}</strong>
      {detail && <span>{detail}</span>}
      {action}
    </div>
  );
}
